import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'FileSelectServiceModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      // テーブルオプション
      tableColumns: [
        [
          'serviceId',
          'serviceName',
          'serviceStatus'
        ],
        [
          'checkbox',
          'serviceId',
          'serviceName',
          'serviceStatus'
        ]
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          serviceId: 'サービスID',
          serviceName: 'サービス名',
          serviceStatus: 'ステータス'
        },
        columnsClasses: {
          checkbox: 'wp-3',
          serviceId: 'wp-5',
          serviceName: '',
          serviceStatus: ''
        },
        sortable: [
          'serviceId',
          'serviceName',
          'serviceStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('サービス'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,
      filterMode: 0,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      serviceModel: state => state.fileSelectServiceModal.serviceModel,
      active: state => state.fileSelectServiceModal.active,
      // form
      values: state => state.file.values
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    modeList () {
      return [
        {
          value: 0,
          label: 'すべてのサービス'
        },
        {
          value: 1,
          label: '選択したサービス'
        }
      ]
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableDetermineButton () {
      if (this.filterMode === 0) return false
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    filterMode (to) {
      if (to === 0) {
        this.$set(this, 'checkList', [])
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      loadModel: 'fileSelectServiceModal/loadModel',
      hide: 'fileSelectServiceModal/hide'
    }),
    ...mapMutations({
      setInputValue: 'file/setInputValue',
    }),

    init () {
      this.loading = true

      if (this.values.inpService &&
        this.values.inpService.length) {
        this.filterMode = 1
        this.checkList = $.extend(true, [], this.values.inpService)
      }

      //TODO
      let serviceParams = {}

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.serviceUuid
        case 'serviceStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    determineValue () {
      console.log('mode : ' + this.filterMode)
      console.log('check : ', this.checkList)
      this.setInputValue({
        key: 'inpService',
        value: this.checkList
      })
      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}